<template>
    <div class="the-hot">
        <div class="title">
            <div class="text">近期热点</div>
            <img src="@img/hot.png" alt="" srcset="">
        </div>
        <div class="list">
            <div class="item" v-for="(item, index) in list" :key="item.text" @click="onClick(item)">
                <img src="@img/num1.png" alt="" v-if="index == 0">
                <img src="@img/num2.png" alt="" v-if="index == 1">
                <img src="@img/num3.png" alt="" v-if="index == 2">
                <span class="plain" v-if="index > 2"> {{ index + 1 }}</span>
                <span class="type">【{{item.type}}】</span>
                <span class="text" :title="item.text">{{item.text}}</span>
            </div>
        </div>
    </div>
</template>

<script>
import {hotList} from '@/config/sys.config'
export default {
    name: "the-hot",
    mixins: [],
    props: {},
    components: {},
    data() {
        return {
          allList: hotList,
          list: []
        }
    },
    methods: {
        onClick(item) {
            this.$emit('click', item)
        },
        randomInt(min, max) {
          return Math.floor(Math.random() * (max - min + 1)) + min;
        }
    },
    mounted() {
      var _this = this;
      if(_this.allList.length<=6){
        _this.list = _this.allList;
      }else{
        var randomIndex = [];
        while(randomIndex.length < 6) {
          var index = _this.randomInt(0, _this.allList.length -1);
          if(!randomIndex.some(item=> item === index)) {
            randomIndex.push(index)
            _this.list.push(_this.allList[index])
          }
        }
      }
    }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/_var.scss';
.the-hot {
    padding: 20px;
    .title {
        font-size: 20px;
        font-weight: bold;
        display: flex;
        align-items: center;
        img {
            margin-left: 5px;
            transform: translateY(-5px);
        }
    }

    .list {
        margin-top: 15px;
        max-height: 220px;
        overflow: hidden;
        .item {
            display: flex;
            align-items: center;
            cursor: pointer;
            .plain {
                width: 20px;
                height: 20px;
                margin-left: 4px;
                display: inline-block;
                display: flex;
                align-items: center;
                justify-content: center;
                background: linear-gradient(135deg, rgba(157, 185, 237, 1) 0%, rgba(201, 219, 255, 1) 46.3%, rgba(157, 185, 237, 1) 100%), rgba(204, 204, 204, 1);
                color: #fff;
            }

            .type {
                margin-left: 10px;
                font-size: var(--font-size);
                flex: 1 0 auto;
            }

            .text {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                width: 110px;
                color: rgba(78, 85, 135, 1);
                font-size: var(--font-size);
            }

            & + .item {
                margin-top: 14px;
            }
        }
    }
}
</style>
